import React, { useContext } from "react";
import VaccinesOutlinedIcon from "@mui/icons-material/VaccinesOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const columns = [
  { field: "id", header: "ID", width: "6rem" },
  { field: "nombre", header: "Apellido y Nombre" },
  { field: "domicilio", header: "Domicilio" },
  { field: "telefono", header: "Teléfono" },
  { field: "email", header: "Email" },
  { field: "numeroDocumento", header: "D.N.I." },
  { field: "cuit", header: "C.U.I.T./C.U.I.L." },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "9rem" },
];

const fields = [
  { name: "nombre", label: "Apellido y Nombre", type: "text", required: true, md: 12 },
  { name: "domicilio", label: "Domicilio", type: "text", md: 12 },
  { name: "telefono", label: "Teléfono", type: "text", md: 4 },
  { name: "email", label: "Email", type: "text", md: 8 },
  { name: "numeroDocumento", label: "D.N.I.", type: "text", md: 6 },
  { name: "cuit", label: "C.U.I.T./C.U.I.L.", type: "text", md: 6 },
  { name: "valorGuardia", label: "Valor Guardia", type: "number", md: 4 },
  { name: "nocturno", label: "% Nocturno", type: "number", min: 0, max: 100, rangeMsg: "Error", md: 4 },
  { name: "sadofe", label: "% Sab. Dom. Fer.", type: "number", min: 0, max: 100, rangeMsg: "Error", md: 4 },
  { name: "habilitado", label: "Habilitado", type: "switch", md: 12 },
];

export default function Enfermeros() {
  const { enfermeros, obtenerEnfermeros, agregarEnfermero, actualizarEnfermero } =
    useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Enfermeros"
      entidad="enfermero"
      layout="Enfermeros"
      icono={<VaccinesOutlinedIcon />}
      items={enfermeros}
      columns={columns}
      fields={fields}
      anchoDialog="md"
      nuevoDefault={{
        nombre: "",
        domicilio: "",
        telefono: "",
        email: "",
        numeroDocumento: "",
        cuit: "",
        valorGuardia: "",
        nocturno: "",
        sadofe: "",
        habilitado: true,
      }}
      onObtener={() => obtenerEnfermeros({ todos: true })}
      onAgregar={(data) => agregarEnfermero({ enfermero: data })}
      onActualizar={(data) => actualizarEnfermero({ enfermero: data })}
    />
  );
}
